import React from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { Grid, GridItem } from '../../../../../ui';
import { IPressRelease } from '../../../../shared/api/contentful/types/IPressRelease';
import PressReleaseCard from './PressReleaseCard';
import { removePaginationFromPath } from '../../../helpers/removePaginationFromPath';
import NewsCardNoImage from '../../../../../../assets/icons/no-image.svg?reference';
import { NoSearchResultsMessage } from '../NoSearchResultsMessage';

interface IHighlighedPressReleaseProps {
	pressReleases: IPressRelease[];
}

export const PressReleaseList = ({
	pressReleases,
}: IHighlighedPressReleaseProps) => {
	const router = useRouter();
	const asPath = removePaginationFromPath(router.asPath);

	return (
		<StyledGrid>
			{pressReleases.length === 0 && <NoSearchResultsMessage />}
			{pressReleases.map((item) => {
				const firstImage = item.images?.[0]?.fields;
				const imageSrc = firstImage?.file.url || NewsCardNoImage;

				return (
					<StyledGridItem columns={[6, { mobileXL: 12 }]} key={item.slug}>
						<PressReleaseCard
							title={item.title}
							imageSource={imageSrc}
							linkHref={`${asPath}/item/${item.slug}`}
							publicationDate={item.publicationDate}
						/>
					</StyledGridItem>
				);
			})}
		</StyledGrid>
	);
};

const StyledGrid = styled(Grid.withComponent('ul'))`
	padding-left: 0;
	list-style: none;
`;

const StyledGridItem = styled(GridItem.withComponent('li'))`
	padding-left: 0;
`;
